import React from 'react';
import { Box } from '@mui/material';
import LandingNavBar from '../navigation/LandingNavBar';
import Footer from './Footer';

const PublicLayout = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <LandingNavBar />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: { xs: 7, md: 8 } // Add padding top to account for fixed navbar
        }}
      >
        {children}
      </Box>

      <Footer />
    </Box>
  );
};

export default PublicLayout;
